import { useMutation } from '@tanstack/react-query'
import { markAsRefundedExternally } from '@/api/ops-api'
import type { OpsApiMarkAsRefundedExternallyRequest } from '@itsrever/rever-api'

const markAsRefunded = async (req: OpsApiMarkAsRefundedExternallyRequest) => {
  const data = await markAsRefundedExternally(req)
  return data
}

export const useMarkAsRefundedExternally = () => {
  return useMutation({
    mutationFn: markAsRefunded
  })
}
